import { Theme } from 'baseui';
import StyleBreakpoint from 'common/styles/styles.breakpoint';
import stylesColors from 'common/styles/styles.colors';
import { themedStyled } from 'common/styles/styletron.theme';

export const HeaderContainer = themedStyled('div', ({ $theme }) => ({
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundColor: $theme.colors.bg1,
  color: 'white',
  display: 'flex',
  flex: '0 0 64px',
  height: '64px',
  paddingLeft: '16px',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const NAVIGATION_ACTIVE_WIDTH = '264px';
export const NAVIGATION_INACTIVE_WIDTH = '0px';

export const SideNavigationContainer = themedStyled<
  'div',
  { $isActive: boolean },
  Theme
>('div', ({ $isActive }) => {
  const maxWidth = $isActive
    ? `${NAVIGATION_ACTIVE_WIDTH} !important`
    : NAVIGATION_INACTIVE_WIDTH;
  const minWidth = $isActive
    ? `${NAVIGATION_ACTIVE_WIDTH} !important`
    : NAVIGATION_INACTIVE_WIDTH;
  const width = $isActive
    ? `${NAVIGATION_ACTIVE_WIDTH} !important`
    : NAVIGATION_INACTIVE_WIDTH;

  return {
    background: 'white',
    minWidth,
    maxWidth,
    position: 'relative',
    width,
    height: '100%',
    overflow: 'scroll',
    backgroundColor: 'white',
    zIndex: 201,
    transition: 'all 0.2s ease',
    boxShadow: '0.1rem 0 0.02rem rgba(0,0,0,0.1)',
    opacity: $isActive ? 1 : 0,

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      position: 'absolute',
      top: 0,
      left: '-264px',
      bottom: 0,
      background: 'white',

      ...($isActive
        ? {
            left: '0px !important',
            position: 'fixed',
          }
        : {}),
    },
  };
});

export const MobileNavigationHeader = themedStyled('div', ({ $theme }) => ({
  display: 'none',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    display: 'block',
    marginRight: '8px',
    marginLeft: '16px',
    borderBottom: `1px solid rgba(211, 217, 222, 0.4)`,
    paddingBottom: '24px',
    marginBottom: '16px',
    paddingTop: '24px',
  },
}));

export const NavigationContainer = themedStyled<
  'div',
  { $isActive: boolean },
  Theme
>('div', ({ $isActive }) => {
  return {
    transition: 'all .18s ease',

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      ...($isActive
        ? {
            opacity: 1,
          }
        : {
            opacity: 0,
          }),
    },
  };
});

const BAR_OBJ = {
  color: stylesColors.primaryDefault,
  width: '22px',
  borderRadius: '1px',
  height: '3px',
  margin: '5px auto',
  '-webkit-transition': 'all 0.2s ease-in-out',
  transition: 'all 0.2s ease-in-out',
  backgroundColor: stylesColors.primaryDefault,
};

export const HamburgerContainer = themedStyled('div', ({ $theme }) => {
  return {
    cursor: 'pointer',
    marginTop: '10px',
    // [`@media screen and (min-width: ${StyleBreakpoint.lg})`]: {
    //   display: 'none',
    // },
  };
});

export const FirstBar = themedStyled<'div', { $isActive: boolean }, Theme>(
  'div',
  ({ $isActive }) => {
    return {
      ...BAR_OBJ,
      ...($isActive
        ? {
            display: 'none',
          }
        : {}),
    };
  },
);

export const SecondBar = themedStyled<'div', { $isActive: boolean }, Theme>(
  'div',
  ({ $isActive }) => {
    return {
      ...BAR_OBJ,
      ...($isActive
        ? {
            transform: 'translateY(4px) rotate(45deg)',
          }
        : {}),
    };
  },
);

export const ThirdBar = themedStyled<'div', { $isActive: boolean }, Theme>(
  'div',
  ({ $isActive }) => {
    return {
      ...BAR_OBJ,
      ...($isActive
        ? {
            transform: 'translateY(-4.3px) rotate(-45deg)',
          }
        : {}),
    };
  },
);

export const HeaderLogoContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flex: 1,
}));

export const HeaderInformationContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const HeaderNotificationContainer = themedStyled(
  'div',
  ({ $theme }) => ({
    display: 'flex',
    backgroundColor: '#FFF',
    marginRight: '32px',
    width: '40px',
    height: '40px',
    borderRadius: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      backgroundColor: 'transparent',
    },
  }),
);

export const HeaderProfileContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  minWidth: '300px',
  height: '64px',
  flex: 1,
  paddingLeft: '24px',
  alignItems: 'center',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    display: 'none',
  },
}));

export const HeaderProfilePicture = themedStyled('div', ({ $theme }) => ({
  marginRight: '16px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const HeaderProfileInformation = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: '16px',
}));

export const LoadingContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  flex: 1,
  padding: '16px',
  height: '100%',
}));

export const TimeContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: '32px',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    display: 'none',
  },
}));

export const HeaderLeftSideContent = themedStyled('div', {
  display: 'flex',
});

export const ProfileMenuContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}));

export const ProfileMenuItem = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flex: 1,
  padding: '12px 20px',
  alignItems: 'center',
  cursor: 'pointer',
  ':hover': {
    background: '#00000018',
  },
}));
